import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { Header } from './Header';
import { LoadingSpinner } from '../ui/LoadingSpinner';
import { useCurrentUser } from '@/shared/hooks/useCurrentUser';
import { isMockAuthEnabled, isInTeams, getStoredTeamsSsoToken, isEmbeddedContext } from '@/lib/auth';
import { CommandPalette } from '../CommandPalette';

export function AuthenticatedLayout() {
  const msalIsAuthenticated = useIsAuthenticated();
  const teamsIsAuthenticated = isInTeams() && !!getStoredTeamsSsoToken();
  const embeddedIsAuthenticated = isEmbeddedContext() && !!getStoredTeamsSsoToken();
  const isAuthenticated = isMockAuthEnabled || msalIsAuthenticated || teamsIsAuthenticated || embeddedIsAuthenticated;
  const { isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white-smoke">
        <LoadingSpinner size="lg" label="Loading application..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex flex-col h-screen bg-white-smoke">
      <CommandPalette />

      {/* Mock Auth Banner */}
      {isMockAuthEnabled && (
        <div className="bg-amber-500 text-amber-900 text-center py-1 text-xs font-medium flex-shrink-0">
          🔧 Local Development Mode - Mock Authentication Enabled
        </div>
      )}

      {/* Header with navigation */}
      <Header />

      {/* Page content */}
      <main className="flex-1 overflow-y-auto p-6">
        <div className="max-w-7xl mx-auto">
          <Outlet />
        </div>

        <footer className="py-4 text-center">
          <p className="text-xs text-gray-400">
            Corus AI Use Case Registry v1.0
          </p>
        </footer>
      </main>
    </div>
  );
}
